// Filter option definitions for the NewsFeedPage - kept separate from filterEngine.js
// since news updates aren't MediaItems and use their own field set (importance/category/source).

export const IMPORTANCE_OPTIONS = [
  { value: 'big', label: 'Big', icon: '/static/icons/star-solid.svg' },
  { value: 'medium', label: 'Medium', icon: '/static/icons/bell-solid.svg' },
  { value: 'small', label: 'Small', icon: '/static/icons/circle-solid.svg' },
  { value: 'personal', label: 'Personal', icon: '/static/icons/user-solid.svg' },
];

export const CATEGORY_OPTIONS = [
  { value: 'news', label: 'News', icon: '/static/icons/newspaper-solid.svg' },
  { value: 'personal', label: 'Personal', icon: '/static/icons/user-solid.svg' },
  { value: 'administrative', label: 'Administrative', icon: '/static/icons/gear-solid.svg' },
];

// `value` is matched server-side as an update_type PREFIX (e.g. 'steam' matches 'steam_achievements',
// 'steam_add_media', etc.) - see `source` param handling in backend/routes/api/newsfeeed_routes.py.
export const SOURCE_OPTIONS = [
  { value: 'steam', label: 'Steam', icon: '/static/icons/steam.svg' },
  { value: 'mal', label: 'MyAnimeList', icon: '/static/icons/myanimelist.svg' },
  { value: 'tmdb', label: 'TMDB', icon: '/static/icons/clapperboard-solid.svg' },
  { value: 'mangadex', label: 'MangaDex', icon: '/static/icons/MangaDex.svg' },
  { value: 'discogs', label: 'Discogs', icon: '/static/icons/discogs.svg' },
  { value: 'igdb', label: 'IGDB', icon: '/static/icons/igdb.svg' },
  { value: 'openlibrary', label: 'Open Library', icon: '/static/icons/book-solid.svg' },
  { value: 'anime', label: 'Anime Progress', icon: '/static/icons/clapperboard-solid.svg' },
  { value: 'manga', label: 'Manga Progress', icon: '/static/icons/book-open-solid-full.svg' },
  { value: 'book', label: 'Book Progress', icon: '/static/icons/book-solid.svg' },
  { value: 'physicalgame', label: 'Physical Games', icon: '/static/icons/gamepad-solid.svg' },
  { value: 'weekly', label: 'Weekly Summary', icon: '/static/icons/calendar-solid.svg' },
  { value: 'monthly', label: 'Monthly Summary', icon: '/static/icons/calendar-solid.svg' },
];
